//interfaces
import {IDoNotTranslateTab} from '../../../../../interfaces/languages';

//hooks
import { UseDoNotTranslateTab } from './DoNotTranslateTab.hooks';

//components
import AddTermModal from '@/components/modals/orgSettings/languages/AddTermModal';
import RemoveTermModal from '../../../../modals/orgSettings/languages/RemoveTermModal';
import { BasicButton, SimpleTable } from 'thrive-components';
import NotificationBar from '../../NotificationBar';

//styles
import "../../../../../css/orgSettings/languages/doNotTranslateTab.scss";



const DoNotTranslateTab = ({show}:IDoNotTranslateTab) => {
    if (!show) { return <></> }

    const {
        termTableContent,
        setRemoveTermItem,
        onRemoveTerm,
        removeTermItem,
        editTermItem,
        onEditTermClick,
        onAddNewTermClick,
        onCloseAddTermModal,
        setShowAddTermModal,
        showAddTermModal,
        notificationDetails
    } = UseDoNotTranslateTab();
    
    return (
        <div className="do-not-translate-tab">            
            <p className='tab-explainer'>
                {
                    `Add specific names or terms that should remain unchanged when content is translated. ` +
                    `Republish previously translated content to apply changes, or use Quick Translate to apply ` +
                    `them to all existing content. Terms are case-sensitive.`
                }
            </p>

            <BasicButton 
                className='add-term-button'
                content={"Add Term"} 
                ariaLabel={'Add term to list of terms which are not translated.'}
                onButtonClick={() => setShowAddTermModal(true)}
            />

            <SimpleTable
                {...termTableContent}
            />

            <AddTermModal 
                showModal={showAddTermModal || !!editTermItem}
                termInformation={editTermItem} 
                onSaveClick={editTermItem ? onEditTermClick : onAddNewTermClick} 
                onCloseClick={onCloseAddTermModal}
            />

            <RemoveTermModal 
                showModal={!!removeTermItem} 
                setRemoveTermItem={()=>setRemoveTermItem(null)} 
                onConfirmClick={() => onRemoveTerm(removeTermItem?.id)}
            />

            <NotificationBar 
                show={notificationDetails.show} 
                notificationStatus={notificationDetails.status} 
                msg={notificationDetails.message}
            />
        </div>
    );
};

export default DoNotTranslateTab;